import { render, staticRenderFns } from "./AreaEmbargadaSedamRo.vue?vue&type=template&id=46c67e7c&lang=pug"
import script from "./AreaEmbargadaSedamRo.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaSedamRo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports